import React from 'react';
import { Nav } from 'react-bootstrap';
import { FaGears } from 'react-icons/fa6';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';

export default function OperationsNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  showHelicopterOpsMenu,
  online,
}) {
  const childRoutes = [
    '/operations/fleet',
    '/operations/fleet/registry',
    '/operations/fleet/categories',
    '/operations/fleet/daily',
    '/operations/fleet/maintenance',
    '/operations/jm',
    '/operations/jm/register',
    '/operations/jm/settings',
    ...(showHelicopterOpsMenu
      ? ['/operations/helicopter', '/operations/helicopter/new', '/operations/helicopter/registry']
      : []),
    '/operations/chat',
    '/operations/fuel-control',
  ];

  if (!hasMenuAccessOrChild('/operations', childRoutes)) {
    return null;
  }

  return (
    <MenuItem customIcon={<FaGears style={{ width: '24px', height: '24px' }} />} title="Operations" id="operations">
      {(hasMenuAccess('/operations/fleet')
        || hasMenuAccess('/operations/fleet/registry')
        || hasMenuAccess('/operations/fleet/categories')
        || hasMenuAccess('/operations/fleet/daily')
        || hasMenuAccess('/operations/fleet/maintenance')) && (
        <>
          <NavSubmenuLabel>Fleet & Equip</NavSubmenuLabel>
          {hasMenuAccess('/operations/fleet') && <SubMenuItem to="/operations/fleet">Project Fleet</SubMenuItem>}
          {hasMenuAccess('/operations/fleet/registry') && (
            <SubMenuItem to="/operations/fleet/registry">Asset Registry</SubMenuItem>
          )}
          {hasMenuAccess('/operations/fleet/categories') && (
            <SubMenuItem to="/operations/fleet/categories">Fleet Categories</SubMenuItem>
          )}
          {hasMenuAccess('/operations/fleet/daily') && <SubMenuItem to="/operations/fleet/daily">Daily Log</SubMenuItem>}
          {hasMenuAccess('/operations/fleet/maintenance') && (
            <SubMenuItem to="/operations/fleet/maintenance">Maintenance</SubMenuItem>
          )}
          <NavSubmenuDivider />
        </>
      )}
      {showHelicopterOpsMenu
        && (hasMenuAccess('/operations/helicopter')
          || hasMenuAccess('/operations/helicopter/new')
          || hasMenuAccess('/operations/helicopter/registry')) && (
        <>
          <NavSubmenuLabel>Transportation</NavSubmenuLabel>
          {hasMenuAccess('/operations/helicopter') && (
            <SubMenuItem to="/operations/helicopter">Helicopter Ops</SubMenuItem>
          )}
          {hasMenuAccess('/operations/helicopter/new') && (
            <SubMenuItem to="/operations/helicopter/new">New Configuration</SubMenuItem>
          )}
          {hasMenuAccess('/operations/helicopter/registry') && (
            <SubMenuItem to="/operations/helicopter/registry">🚁 Helicopter Registry</SubMenuItem>
          )}
        </>
      )}
      {hasMenuAccess('/operations/fuel-control') && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Fuel</NavSubmenuLabel>
          <SubMenuItem to="/operations/fuel-control">⛽ Fuel Control</SubMenuItem>
        </>
      )}
      {(hasMenuAccess('/operations/jm')
        || hasMenuAccess('/operations/jm/register')
        || hasMenuAccess('/operations/jm/settings')) && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Radio Ops</NavSubmenuLabel>
          {hasMenuAccess('/operations/jm') && (
            <SubMenuItem to="/operations/jm">📻 JM</SubMenuItem>
          )}
          {hasMenuAccess('/operations/jm/register') && (
            <SubMenuItem to="/operations/jm/register">Register</SubMenuItem>
          )}
          {hasMenuAccess('/operations/jm/settings') && (
            <SubMenuItem to="/operations/jm/settings">JM Settings</SubMenuItem>
          )}
        </>
      )}
      {hasMenuAccess('/operations/chat') && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Comms</NavSubmenuLabel>
          {online ? (
            <SubMenuItem to="/operations/chat">💬 Operations Chat</SubMenuItem>
          ) : (
            <Nav.Link
              className="ps-5 py-1 d-block text-truncate sidebar-submenu-item text-white-50"
              style={{ opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' }}
            >
              💬 Operations Chat
            </Nav.Link>
          )}
        </>
      )}
    </MenuItem>
  );
}
